import axios from 'axios';

const chargingInfoApi = '/charging/info/api';

export const getLocationsApi = csrfToken => {
  return axios.post(`${chargingInfoApi}/get-locations`, undefined, {
    headers: {
      'CSRF-Token': csrfToken,
    },
  });
};

export const getHomeChargersApi = (csrfToken, data) => {
  return axios.post(`${chargingInfoApi}/get-home-chargers`, data, {
    headers: {
      'CSRF-Token': csrfToken,
    },
  });
};

export const getLocationsV2Api = csrfToken => {
  return axios.post(`${chargingInfoApi}/v2/get-locations`, undefined, {
    headers: {
      'CSRF-Token': csrfToken,
    },
  });
};

export const getHomeChargersV2Api = (csrfToken, data) => {
  return axios.post(`${chargingInfoApi}/v2/get-home-chargers`, data, {
    headers: {
      'CSRF-Token': csrfToken,
    },
  });
};

export const get3rdPartyChargersApi = (csrfToken, data) => {
  return axios.post(`${chargingInfoApi}/v2/get-3rd-party-chargers`, data, {
    headers: {
      'CSRF-Token': csrfToken,
    },
  });
};

export const getSelectedLocationDetailApi = (csrfToken, data) => {
  return axios.post(`${chargingInfoApi}/v2/get-location-detail`, data, {
    headers: {
      'CSRF-Token': csrfToken,
    },
  });
};

export const getLocationsDetailApi = (csrfToken, data) => {
  return axios.post(`${chargingInfoApi}/v2/get-locations-detail`, data, {
    headers: {
      'CSRF-Token': csrfToken,
    },
  });
};
